import React from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { EXPERTS } from '@guuru/expert-common';

const RelativeWrapperDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

const AbsoluteAvatarDiv = styled.div`
  position: absolute;
  transform: translateY(-85px);
`;

const StyledAvatar = styled(Avatar)`
  box-shadow: 0 1px 7px rgba(0 0 0 / 25%);
  border: ${({ theme }) => `1px solid ${theme.onPrimaryColor}`};
  bottom: -20px;

  img {
    width: inherit !important;
    height: inherit !important;
  }
`;

interface ExpertFeedbackAvatarProps {
  expertPhoto: string;
}

const ExpertFeedbackAvatar = function ({
  expertPhoto,
}: ExpertFeedbackAvatarProps) {
  if (expertPhoto === EXPERTS.default.photoUrl) return null;
  return (
    <RelativeWrapperDiv aria-hidden="true">
      <AbsoluteAvatarDiv>
        <StyledAvatar
          size={90}
          src={expertPhoto}
        />
      </AbsoluteAvatarDiv>
    </RelativeWrapperDiv>
  );
};

export default ExpertFeedbackAvatar;
